import React, { FC, useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
import { getMemberInfo } from 'src/utils/common';
import {
  settlementInfoDataFn,
  settlementNtsInfoDataFn,
  selectNtsFileFn,
} from 'src/fetch/stepC/settlement';
import { settlementNtsDataStore, ntsFileDataStore } from 'src/store/settlementInfo';
import Template from './template';

interface Props {
  num: number;
}

const StepC: FC<Props> = ({ num }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingSate = loadingModalViewStore((state: any) => state.set);

  // 정산결과
  const settlementNtsInfoState = settlementNtsDataStore((state: any) => state.bind);
  const settlementNtsInfoParam = settlementNtsDataStore((state: any) => state.param);
  // NTS 업로드파일 데이터
  // const ntsFileState = ntsFileDataStore((state: any) => state.bind);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);
  const param = userInfoData;

  // 정산결과
  // useEffect(() => {
  //   const param: any = userInfoData;
  //   settlementInfoDataFn(errorModalState, param, settlementDataInitState, queryClient);
  // }, [settlementDataParam]);

  return (
    <div className="_step_layout">
      <Template num={num} />
    </div>
  );
};

export default StepC;
